import type { DesktopAthlete } from '@/api/athletesApi'

const dayNumber = (year: number, month: number, day: number) => Date.UTC(year, month - 1, day) / 86400000
const leapYear = (year: number) => year % 4 === 0 && (year % 100 !== 0 || year % 400 === 0)

export function upcomingBirthdays(athletes: DesktopAthlete[], now: Date, horizon = 30) {
  const year = now.getFullYear()
  const today = dayNumber(year, now.getMonth() + 1, now.getDate())
  return athletes.flatMap(athlete => {
    const birth = athlete.date_of_birth?.slice(0, 10)
    if (!birth || !/^\d{4}-\d{2}-\d{2}$/.test(birth)) return []
    const [birthYear, month, day] = birth.split('-').map(Number)
    const check = new Date(birthYear, month - 1, day, 12)
    if (birthYear < 100 || check.getFullYear() !== birthYear || check.getMonth() + 1 !== month || check.getDate() !== day || dayNumber(birthYear, month, day) > today) return []
    const birthdayDay = (inYear: number) => month === 2 && day === 29 && !leapYear(inYear) ? 28 : day
    let nextYear = year
    if (dayNumber(nextYear, month, birthdayDay(nextYear)) < today) nextYear++
    const nextDay = birthdayDay(nextYear)
    const daysAway = dayNumber(nextYear, month, nextDay) - today
    if (daysAway > horizon) return []
    return [{ athlete, daysAway, age: nextYear - birthYear, date: `${nextYear}-${String(month).padStart(2, '0')}-${String(nextDay).padStart(2, '0')}`, shiftedLeapDay: nextDay !== day }]
  }).sort((a, b) => a.daysAway - b.daysAway || a.athlete.name.localeCompare(b.athlete.name, 'ru'))
}

export function birthdayAgeLabel(age: number) {
  const word = age % 100 >= 11 && age % 100 <= 14 ? 'лет' : age % 10 === 1 ? 'год' : age % 10 >= 2 && age % 10 <= 4 ? 'года' : 'лет'
  return `${age} ${word}`
}
